(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const anchorSection = document.querySelector('.anchor-list__section')
    const stickyHeader = document.querySelector('hh-sticky-header')

    if (!anchorSection || !stickyHeader) return

    const updateAnchorOffset = () => {
      const isHeaderHidden = stickyHeader._state === 1

      anchorSection.style.top = isHeaderHidden
        ? '0px'
        : getComputedStyle(document.documentElement)
            .getPropertyValue('--hh-total-header-height')
    }

    let ticking = false

    window.addEventListener('scroll', () => {
      if (ticking) return

      requestAnimationFrame(() => {
        updateAnchorOffset()
        ticking = false
      })

      ticking = true
    })

    updateAnchorOffset()

    document.querySelectorAll('.anchor-list-item').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const targetId = button.getAttribute('href').replace('#', '')
        const targetElement = document.querySelector(
          `[data-anchor-target="${targetId}"]`
        )

        if (!targetElement) return

        const headerOffset =
          parseInt(
            getComputedStyle(document.documentElement)
              .getPropertyValue('--hh-total-header-height')
          ) || 0

        const y =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset -
          40

        window.scrollTo({
          top: y,
          behavior: 'smooth',
        })
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
